import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import { fetcher, endpoints } from 'src/utils/axios';
// types
import { IResponse } from 'src/types/DTO/IResponse';

import { IParamBasic } from 'src/types/ParamBasic';
import { IReaderAccountFee } from 'src/types/DTO/readerAccountFee/IReaderAccountFee';
import { toReaderAccountFees } from 'src/mapper/ReaderAccountFee.mapper';

// ----------------------------------------------------------------------

// XỬ LÝ PUBLIC API PHÍ MỞ THẺ

// ----------------------------------------------------------------------

export function useGetPublicReaderAccountFees(params?: IParamBasic) {
  const URL = params
    ? [
        endpoints.public.reader_account_fee,
        {
          params: {
            ...params,
          },
        },
      ]
    : endpoints.reader_account_fee;
  // console.log('useGetReaders', params, URL);

  const { data, isLoading, error, isValidating, mutate } = useSWR<IResponse<IReaderAccountFee[]>>(
    URL,
    fetcher
  );

  // console.log(data, isLoading, error, isValidating);

  const readerAccountFees = toReaderAccountFees(data?.data.list);
  const memoizedValue = useMemo(
    () => ({
      data: {
        status: data?.status,
        message: data?.message,
        data: {
          list: readerAccountFees || [],
          pagination: data?.data.pagination,
        },
      },
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, isLoading, error, isValidating, mutate]
  );

  return memoizedValue;
}
